import { CompanyGSTTypes } from "../../../Types/CommonConstants";
import { Voucher_Type } from "../../Services/VoucherServices";

export const partyIsGstType = (
  splitPathInVchType: Voucher_Type,
  currencyPartyGStType: CompanyGSTTypes,
  partyIsGstRegistered?: CompanyGSTTypes,
  partyIsGstRegisteredSalesInvoice?: CompanyGSTTypes
) => {
  // console.log(
  // "partyIsGstRegistered",
  // splitPathInVchType,
  // partyIsGstRegistered,
  // currencyPartyGStType
  // partyIsGstRegisteredSalesInvoice
  // );
  if (
    splitPathInVchType === Voucher_Type.PurchaseVoucher ||
    splitPathInVchType === Voucher_Type.PurchaseOrder
  ) {
    if (
      (partyIsGstRegistered === CompanyGSTTypes.Regular &&
        currencyPartyGStType !== CompanyGSTTypes.Regular) ||
      (partyIsGstRegistered !== CompanyGSTTypes.Regular &&
        currencyPartyGStType === CompanyGSTTypes.Regular) ||
      (partyIsGstRegistered === CompanyGSTTypes.Consumer &&
        currencyPartyGStType !== CompanyGSTTypes.Consumer) ||
      (partyIsGstRegistered !== CompanyGSTTypes.Consumer &&
        currencyPartyGStType === CompanyGSTTypes.Consumer) ||
      (partyIsGstRegistered === CompanyGSTTypes.Unregistered &&
        currencyPartyGStType !== CompanyGSTTypes.Unregistered) ||
      (partyIsGstRegistered !== CompanyGSTTypes.Unregistered &&
        currencyPartyGStType === CompanyGSTTypes.Unregistered)
    ) {
      return currencyPartyGStType;
    }
  } else if (
    splitPathInVchType === Voucher_Type.SalesVoucher ||
    splitPathInVchType === Voucher_Type.Quotation ||
    splitPathInVchType === Voucher_Type.SalesOrder ||
    splitPathInVchType === Voucher_Type.PInvoice
  ) {
    if (
      (partyIsGstRegisteredSalesInvoice !== CompanyGSTTypes.Overseas &&
        currencyPartyGStType === CompanyGSTTypes.Overseas) ||
      (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas &&
        currencyPartyGStType !== CompanyGSTTypes.Overseas) ||
      (partyIsGstRegisteredSalesInvoice !== CompanyGSTTypes.SEZ &&
        currencyPartyGStType === CompanyGSTTypes.SEZ) ||
      (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ &&
        currencyPartyGStType !== CompanyGSTTypes.SEZ)
    ) {
      return currencyPartyGStType;
    }
  }
};
